<template>
	<div v-if="state" :class="{ 'assets-sliding-panel': true, 'open': isOpened, 'drawer-open': isOpened && open_proximity_panel}">

		<div class="main-panel">

			<a href="#" class="app-shadow actions-panel-toggle-btn" @click.prevent="togglePanel"><span class="fas" v-bind:class="'fa-chevron-' + toggle_btn_class"></span></a>
			<div class="inner-block app-shadow">
				<nav class="nav assets-menu">
					<button class="nav-link" :class="{'active': active_tab == 'people'}" @click="active_tab = 'people'">People</button>
					<button class="nav-link" :class="{'active': active_tab == 'equipment'}" @click="active_tab = 'equipment'">Equipment</button>
					<button class="nav-link" :class="{'active': active_tab == 'vehicles'}" @click="active_tab = 'vehicles'">Vehicles</button>
				</nav>
				<div v-if="active_tab == 'people'">
					<div class="actions d-flex align-items-center mb-3">
						<div class="mx-3">Mode</div>
						<select class="form-control" v-model="mode">
							<option value="find">Find</option>
							<option v-if="$auth.hasAccess('trace')" value="trace">Trace</option>
							<option v-if="$auth.hasAccess('profile-panel')" value="profile">Profile</option>
							<option v-if="$auth.hasAccess('proximity-panel')" value="proximityReport">Proximity Contact Trace</option>

						</select>
						<button class="btn btn-dark mx-3 text-nowrap d-flex align-items-center" @click="show_message = true" :disabled="selected_workers.length == 0">
							<i class="fas fa-envelope text-secondary mr-2"></i> MESSAGE
						</button>

					</div>

					<!-- SEARCH FILTERS -->
					<div class="filters d-flex align-items-center mb-3">
						<b-form-input v-model="searchText" type="text" placeholder="Search" class="mx-3"></b-form-input>
						<a href="#" @click.prevent="searchText = '';" class="clear-search text-dark"><i class="fas fa-times"></i></a>
						<b-form-checkbox id="checkbox1" v-model="row_colors" value="1" unchecked-value="0" class="text-nowrap mr-3">
							Show Company Color
						</b-form-checkbox>
					</div>


					<div class="list">
						<table class="table table-striped table-hover">
							<thead class="bordered-header">
								<tr>
									<th width='1'><i class="far fa-envelope"></i></th>
									<th class="pointer sortable" :class="{'selected-sort': selectedSort == 'name', 'desc': sortDirection == -1}" v-if="$auth.hasAccess('worker.name')" @click.prevent="selectedSort = 'name'; sortDirection = sortDirection*-1">Name</th>
									<th class="pointer sortable" :class="{'selected-sort': selectedSort == 'badge_number','desc': sortDirection == -1}" @click.prevent="selectedSort = 'badge_number'; sortDirection = sortDirection*-1" v-else>Badge #</th>
									<th class="pointer" :class="{'selected-sort': selectedSort == 'trade', 'desc': sortDirection == -1}" @click.prevent="selectedSort = 'trade'; sortDirection = sortDirection*-1">Trade</th>
									<th>Icon</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="row in sortedPeople" v-bind:key="row.id" :style="[row_colors == 1 ? { background: row.company.bg_color + ' !important', color: rowColor(row) } : '' ]" class="pointer" @click="selectedRow = (selectedRow == row.id ? null : row.id); callAction(row)" :class="{'selected': selectedRow == row.id }">
									<td>
										<input type="checkbox" @click.stop v-model="selected_workers" :value="row.id" :id="'message='+row.id">
									</td>
									<td>
										<span v-if="$auth.hasAccess('worker.name')">{{row.first_name}} {{row.last_name}}</span>
										<span v-else>{{row.badge_number}}</span>
									</td>
									<td>
										<i>{{worker_types[row.type].label}} / {{$config.job_types[row.job].label}}</i>
									</td>
									<td>
										<img class="mr-3 icon" :src="row.picture" v-if="$auth.hasAccess('worker.picture')"/>
										<img class="mr-3 worker-icon" :style="{backgroundColor: row.company.bg_color}" :src="$worker.getIcon(row)" v-else/>
									</td>
								</tr>
							</tbody>
						</table>

					</div>
				</div>
				<div v-if="active_tab == 'equipment'">
					<div class="container">
						<b-alert variant="warning" show>There are no equipment assets currently tracked.</b-alert>

					</div>
				</div>
				<div v-if="active_tab == 'vehicles'">
					<div class="container"  v-if="Object.keys(vehicles).length == 0">
						<b-alert variant="warning" show>There are no vehicle assets currently tracked.</b-alert>
					</div>
					<div class="list" v-else>
						<table class="table table-striped table-hover">
							<thead>
								<tr>
									<th>Name</th>
									<th>Type</th>

								</tr>
							</thead>
							<tbody>
								<tr v-for="row in vehicles" v-bind:key="row.id" @click="handlerClickRow(row)" :style="[row_colors == 1 ? { backgroundColor: row.company.bg_color, color: rowColor(row) } : '' ]">
									<td :class="{'has-extra': selectedRow == row.id && action == 'buzz' }">
										<span>{{row.name}}</span>

										<div class="buttons" v-if="row.id === selectedRow" :id="'item-' + row.id">
											<span>{{row.name}}</span>
											<span><b-button variant="light" @click="find(row)">Find</b-button></span>
										</div>

									</td>
									<td>
										<i>{{$config.vehicle_types[row.type].label}}</i>
									</td>
								</tr>
							</tbody>
						</table>

					</div>
				</div>
			</div>
		</div>
		<div class="drawer-wrapper">
			<div class="drawer app-shadow">
				<div class="py-3 mx-4">
					<h5>
						<b>
							<span v-if="rec">Proximity Contact Tracing: {{ $worker.getName(rec.id) }}</span>
							<span v-else>Latest Proximity Alerts</span>
						</b>
					</h5>
					<form class="form-inline">
						<div class="form-group mb-2">
							<label for="date-start" class="mr-lg-2">Report Date Range: </label>
						</div>
						<div class="form-group mb-2">
							<date-picker id="date-start" v-model="date_start" type="date" format="M/D/YY" show-hour="false" :show-minute="false" lang="en" class="input-size-1 mx-lg-2"></date-picker>
						</div>

						<div class="form-group mb-2">
							<label for="date-end" class="">to: </label>
						</div>
						<div class="form-group mb-2">
							<date-picker id="date-end" v-model="date_end" type="date" format="M/D/YY" disabled-time="true" lang="en" class="input-size-1 mx-lg-2"></date-picker>
						</div>
						<div class="form-group mb-2 mr-auto">
							<button class="btn btn-sm border border-dark mr-2" :class="{'btn-highlight': range == 14}" type="button" href="#" @click="toggleDateRange(14)"> LAST 14 DAYS</button>
							<button class="btn btn-sm border border-dark" :class="{'btn-highlight': range == 3}" type="button" href="#" @click="toggleDateRange(3)"> LAST 3 DAYS</button>
						</div>

						<div class="form-group mb-2">
							<button class="btn btn-sm btn-white border border-dark" type="button" @click="prtPrint" v-if="rec"> PRINT CONTACT LIST</button>
							<button class="btn btn-sm btn-white border border-dark" type="button" @click="prtExport" v-if="!rec"> EXPORT </button>
						</div>

					</form>

					<div class="proximity-report-table mt-2" v-if="rec">

						<DataTable
							ref="prti"
							title=""
							:columns="columns.individual"
							:rows="alert"
							:searchable="false"
							:exportable="false"
							:printable="false"
							:loadingAnimation="false"
							class="table"
						>
							<template slot="print-header">
								<img :src="`${location.logo}`" style="max-height: 40px;">
								<div style="text-align: center; font-size: 1.35rem">
									<b>Workforce Contact Report: {{ $worker.getName(rec.id) }}<br>
									Between {{$datetime.format(date_start, 'MM/DD/YY')}} to {{$datetime.format(date_end, 'MM/DD/YY')}}</b>
								</div>
							</template>
						</DataTable>
					</div>

					<div class="proximity-report-table mt-2" v-else>
						<DataTable
							ref="prtg"
							title=""
							:columns="columns.general"
							:rows="alert"
							:searchable="false"
							:exportable="false"
							:printable="false"
							:loadingAnimation="false"
						>
						</DataTable>

					</div>
				</div>
			</div>
		</div>


		<b-modal ref="print-modal" title="Print Contact List" v-model="print_modal" class="app-modal" centered size="xl">

			<iframe name="iPrint" src="" class="border-0 w-100" style="height: 80vh"></iframe>

			<div slot="modal-footer">
				<button type="button" class="btn btn-primary pl-4 pr-4" @click="forcePrint">Print</button>
				<button type="button" class="btn btn-dark pl-4 pr-4" @click="print_modal=false">Close</button>
			</div>

		</b-modal>


	</div>
</template>

<script>
	import * as workerTimers from 'worker-timers';
	import { mapState } from 'vuex';
	import * as tinycolor from 'tinycolor2';
	import eventHub from '../../plugins/eventHub';
	import ProximityReport from './AssetsPanel/ProximityReport';
	import DataTable from "@regiscamimura/vue-datatable";
	import DatePicker from 'vue2-datepicker';

	const availableSort = [
		{ value: null, text: 'Sort by' },
		{ value: 'name', text: 'By name' },
		{ value: 'trade', text: 'By trade' },
		{ value: 'job', text: 'By job description' }
	];
	const fields = [
		{ key: 'name', label: 'Name' },
		{ key: 'trade', label: 'Trade' },
		{ key: 'icon', label: 'Icon'}
	];

	export default {
		name: 'AssetsPanel',
		props: {
			state: String,
			onToggleOpen: Function,
			isOpened: Boolean,
			tinycolor: tinycolor
		},
		components: {DataTable, DatePicker},
		mixins: [ProximityReport],
		data() {
			return {
				selectedRow: null,
				active_tab: 'people',
				map_to: null,
				selectedSort: this.$auth.hasAccess('worker.name') ? 'name' : 'badge_number',
				availableSort,
				fields,
				action: null,
				action_to: null,
				row_colors: 0,
				mode: 'find',
				sortDirection: 1,
				print_modal: false,
				searchText: '',
			}
		},
		computed: {
			selected_workers: {
				get() { return this.$store.state.selected_workers},
				set(value) { this.$store.commit('setState', ['selected_workers', value])}
			},
			show_message: {
				get() { return this.$store.state.show_message},
				set(value) { this.$store.commit('setState', ['show_message', value])}
			},
			...mapState([
				'workers',
				'filteredWorkers',
				'flash',
				'lock',
				'speed',
				'sprites',
				'companies',
				'vehicles',
				'proximity',
				'start_date',
				'location'
			]),
			flash: {
				get() { return this.$store.state.flash },
				set(value) { this.$store.commit('setState', ['flash', value])}
			},
			worker_types() { return this.$config.worker_types },
			toggle_btn_class() {
				const {isOpened} = this;
				return isOpened ? 'left' : 'right'
			},
			sortedPeople: function() {
				const {filteredWorkers: workers} = this;
				const a = Object.keys(workers).map(i => workers[i]);
				let b;
				let ret;
				switch (this.selectedSort) {
					case 'name':
						b = a.sort((a, b) => {
							if (a.first_name > b.first_name) return this.sortDirection;
							if (a.first_name < b.first_name) return this.sortDirection;
							return 0;
						});
						break;
					case 'badge_number':
						b = a.sort((a, b) => {
							if (a.badge_number > b.badge_number) return this.sortDirection;
							if (a.badge_number < b.badge_number) return this.sortDirection;
							return 0;
						});
						break;
					case 'job':
						b = a.sort((a, b) => {
							if (a.job > b.job) return this.sortDirection;
							if (a.job < b.job) return this.sortDirection;
							return 0;
						});
					break;

					case 'trade':
						b = a.sort((a, b) => {
							if (a.job > b.job) return this.sortDirection;
							if (a.job < b.job) return this.sortDirection;
							return 0;
						});
					break;

					default:
						b = a;
					break;
				}

				return b;
			},
			map() {
				return this.$store.state.map.map
			},
			floor_level: {
				get() {
					return this.$store.state.floor_level
				},
				set(value) {
					this.$store.commit('setState', ['floor_level', value])
				}
			}
		},
		watch: {
			mode() {
				this.rec = null;
				this.selectedRow = null;
				if (this.mode != 'trace') eventHub.$emit('hide-trace-window');
				if (this.mode == 'proximityReport') this.open_proximity_panel = true;
				else this.open_proximity_panel = false;

			},
			isOpened() {
				if (!this.isOpened) eventHub.$emit('hide-trace-window');
			},
			searchText() {
				this.$store.dispatch('filterWorkers', this.searchText);
			}
		},
		mounted() {

		},
		methods: {
			togglePanel() {
				if (this.isOpened) {
					this.$router.push('/');
				}
				else this.$router.push('location/assets');
			},
			handlerClickRow(row) {
				this.selectedRow = row.id;
				this.action = null;
			},
			callAction(row) {
				eventHub.$emit('hide-trace-window');
				this.$URL.set({ 'asset-log': null });
				this[this.mode](row);
			},
			find(item) {
				eventHub.$emit('find', item.id);
				let center = this.map.getView().getCenter();
				center = item.coordinates;
				let flash_object = {};
				flash_object[item.id] = {id: item.id, flash: 'light', duration: 5000}
				this.flash = flash_object;
				// this.$set(this.flash, item.id, {
				// 	id: item.id,
				// 	flash: 'light',
				// 	duration: 5000
				// });
				this.map.getView().animate({
					center: center,
					zoom: 20,
					duration: 1000
				});
				this.floor_level = item.floor_level;
				this.action = 'find';
			},
			trace(item){
				eventHub.$emit('show-trace-window', item.id);
			},
			profile(item) {
				let id = item.id
				this.$URL.set({
					'asset-log': id
				});
				this.action = 'profile';
			},
			rowColor(row) {
				return tinycolor(row.company.bg_color).isLight() ? 'inherit' : '#fff'
			},
			prtPrint() {
				let ref = this.rec ? this.$refs.prti : this.$refs.prtg;
				this.print_modal = true;
				setTimeout(function() {
					ref.print('iPrint');
				}, 350);
			},
			forcePrint() {
				let ref = this.rec ? this.$refs.prti : this.$refs.prtg;

				ref.win.print();

			},
			prtExport() {
				let ref = this.rec ? this.$refs.prti : this.$refs.prtg;
				ref.exportExcel();
			}
		}
	}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
	$row-width: 605px;
	$assets-panel-width: 620px;
	.assets-menu {
		position: relative;
		background-color: #E6E7E8;
		height: 50px;
		padding: 0 0 0 100px;
		border-bottom: 1px solid #929396;
		margin-bottom: 20px;

		& .nav-link {
			border: 0;
			cursor: pointer;
			border-left: 1px solid #929396;
			color: #929396;
			font-size: 20px;
			line-height: 33px;
			background: #ccc;

			&:last-child {
				border-right: 1px solid #929396;
			}

			&:focus {
				outline: none;
			}
			&.active {
				background-color: #fff;
				color: #747474;
			}
		}
	}
	.clear-search {
		position: absolute;
		left: 66%;
	}


	.icon {
		width: 20px;
		height: 20px;
	}
	.worker-icon {
		width: 25px;
		height: 25px;
		padding: 5px;
		border-radius: 15px;
	}

	.list {
		height: calc(100% - 164px);
		overflow-y: scroll;
		position: absolute;
		width: 100%;
		z-index: 4;
	}
	.proximity-report-table {

		width: calc(100% - 15px);
		margin-left: -15px;
		margin-right: -15px;
		position: absolute;
		height: 100%;
		padding: 5px 15px;
		.datatable-wrapper {
			height: calc(100% - 129px);
			overflow-y: scroll;
			width: 100%;
		}
	}

	.assets-sliding-panel {
		position: absolute;
		left: $assets-panel-width * -1;
		top: 0;
		bottom: 68px;
		z-index: 999;
		background: rgba(255, 255, 255, 1);
		transition-duration: 0.4s;
		transition-timing-function: ease;
		transition-property: left, width;
		width: $assets-panel-width;
		height: 100%;
		&.drawer-open {
			width: 100%;
		}
		.main-panel {
			width: $assets-panel-width;
			height: 100%;
			position: relative;
		}
		.inner-block {
			height: 100%;
			z-index: 999;
			position: absolute;
			width:100%;
			background: #fff;
			>div {
				height: 100%;
			}

		}
		.actions-panel-toggle-btn {
			color: #f49230;
			position: absolute;
			background: #fff;
			width: 20px;
			height: 50px;
			top: 50%;
			margin-top: -25px;
			line-height: 50px;
			text-align: center;
			z-index: 999;
			right: -20px;
		}
		&.open {
			left: 0;
			.drawer-wrapper {
				display: block;
				opacity: 1;
				transition-duration: 0s;
				transition-delay: 0.4s;
				transition-timing-function: ease;
				transition-property: opacity;
			}
		}

		.drawer-wrapper {
			opacity: 0;
			display: none;
		}
	}
	.drawer {
		position: absolute;
		width: calc(100vw - #{$assets-panel-width});
		height: 100%;
		top: 0;
		right: 0;
		z-index:1;
		background: #fff;

	}


</style>
